<template>
  <q-dialog v-model="confirm" persistent>
    <q-card>
      <q-card-section class="row items-center">
        <q-avatar icon="logout" color="negative" text-color="white" />
        <span class="q-ml-sm">Do you want to revoke all acces for this user?.</span>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn flat label="Cancel" color="warning" v-close-popup />
        <q-btn flat :loading="isSubmitted" label="Force Logout" color="positive" @click="confirmLogout" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { useQuasar } from 'quasar' 
import { ref } from 'vue'
import axios from 'axios'
import EventBus from "@/EventBus"
export default {
  setup () {
    const token = ref(window.$cookies.get(process.env.VUE_APP_API_KEY).token)
    const $q = useQuasar()
    const confirm = ref(false)
    const id = ref(null)
    const isSubmitted = ref(false)

    EventBus.on("logoutModal",(val) => {
        id.value = val.id
        confirm.value = val.status
    })

    const confirmLogout = () => {
      isSubmitted.value = true; 
      axios.get(process.env.VUE_APP_API_URL + '/user/'+ id.value,{
        headers: { 'Authorization': `Bearer ${token.value}`},
      }).then((response) => {
          isSubmitted.value = false
          confirm.value = false
          $q.notify({
            color: 'positive',
            textColor: 'white',
            icon: 'check_circle',
            message: response.data.message
          })
         EventBus.emit("refreshData")
        }).catch((e) => {
         isSubmitted.value = false
         $q.notify({
            color: 'negative',
            textColor: 'white',
            icon: 'warning',
            message: e.response.data.message
          })
      })
    }

    return {
      token,
      confirm,
      id,
      isSubmitted,
      confirmLogout
    }
  }
}
</script>